import {
  ApolloLink,
  defaultDataIdFromObject,
  InMemoryCache,
  StoreObject
} from '@apollo/client';
import { RemoveTypenameFromVariablesLink } from '@apollo/client/link/remove-typename';
import { inject } from '@angular/core';
import { HttpLink } from 'apollo-angular/http';

export const apolloBaseHelper = (uri: string, ...links: ApolloLink[]) => {
  const httpLink = inject(HttpLink);

  const http = httpLink.create({
    uri
  });

  const link = ApolloLink.from([
    new RemoveTypenameFromVariablesLink(),
    ...links,
    http
  ]);

  return {
    link,
    cache: new InMemoryCache({
      dataIdFromObject: (object: Readonly<StoreObject>) =>
        defaultDataIdFromObject(object)
    })
  };
};
